import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import UpdateChecker from './components/UpdateChecker';
import Base64 from './pages/Base64';
import Home from './pages/Home';
import Html from './pages/Html';
import Json from './pages/Json';
import Jwt from './pages/Jwt';
import Markdown from './pages/Markdown';
import Url from './pages/Url';
import Xml from './pages/Xml';
import Yaml from './pages/Yaml';
import { AlertProvider } from './providers/AlertProvider';
import Layout from './pages/Layout';

function App() {

    return (
        <AlertProvider>
            <UpdateChecker/>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <ScrollToTop />
                <Routes>
                    <Route path="" element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/json" element={<Json />} />
                        <Route path="/xml" element={<Xml />} />
                        <Route path="/yaml" element={<Yaml />} />
                        <Route path="/html" element={<Html />} />
                        <Route path="/url" element={<Url />} />
                        <Route path="/base64" element={<Base64 />} />
                        <Route path="/jwt" element={<Jwt />} />
                        <Route path="/markdown" element={<Markdown />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AlertProvider>
    );
}

export default App;
